import { IApiManufactory } from '@tap/data-providers';
import { ITreeViewCheckboxItem, TreeViewCheckboxList } from '@tap/mui-ui';
import { ExtSector } from '.';
import { useMemo } from 'react';

const useDepartmentTree = (data: IApiManufactory[], selectedDepartmentIds: number[]): {
    departmentTree: ITreeViewCheckboxItem,
    selectedItems: string[],

} => {
    const selectedItems = [] as string[];
    const departmentTree = {
        id: 'all',
        name: 'Все',
        children: data.map(m => ({
            id: m.name,
            name: `Цех ${m.name}`,
            children: m.sectors.map(s => {
                const node = {
                    id: `${m.name}.${s.name}`,
                    departmentId: s.id,
                    name: `Участок ${s.name}`,
                };
                if (selectedDepartmentIds.includes(s.id)) {
                    selectedItems.push(node.id);
                }
                return node;
            }),
        })),
    };

    return { departmentTree, selectedItems };
}

export const DepartmentSelectTree = ({ manufactoryList, sectorList, selectedDepartmentIds, onChange }: {
    manufactoryList: IApiManufactory[],
    sectorList: ExtSector[],
    selectedDepartmentIds: number[],
    onChange: (departmentIds: number[]) => void,
}) => {
    const { departmentTree, selectedItems } = useMemo(() => {
        return useDepartmentTree(manufactoryList, selectedDepartmentIds);
    }, [manufactoryList, selectedDepartmentIds]);

    const handleSetSelectedItems = (items: string[]) => {
        const departmentIds = sectorList.filter(s => items.includes(s.fullName)).map(s => s.departmentId);
        onChange && onChange(departmentIds);
    };

    return (
        <TreeViewCheckboxList
            items={departmentTree}
            selectedItems={selectedItems}
            handleSetSelectedItems={handleSetSelectedItems}
            treeViewStyle={{ width: '100%' }}
        />
    );
}